import { render, staticRenderFns } from "./ProductTileB2C.vue?vue&type=template&id=717c9584&scoped=true&"
import script from "./ProductTileB2C.ts?vue&type=script&lang=ts&"
export * from "./ProductTileB2C.ts?vue&type=script&lang=ts&"
import style0 from "./ProductTileB2C.vue?vue&type=style&index=0&id=717c9584&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717c9584",
  null
  
)

export default component.exports